module.exports = __webpack_public_path__ + "img/active-20220816.00c6841e.png";